import React, { useState, useEffect } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';

function Footer() {

    let history = useHistory();
    const location = useLocation();

    useEffect(() => {
        getEventDataFooter();
        getCategoryDataFooter();
        getCMSData();
    }, [])

    const [disable, setDisable] = useState(false);
    const [errors, setErrors] = useState({});
    const [events, setEvents] = useState({});
    const [categories, setCategories] = useState({});
    const [fb, setFb] = useState("");
    const [linkedin, setLinkedin] = useState("");
    const [twitter, setTwitter] = useState("");
    const [insta, setInsta] = useState("");
    const [footerText, setFooterText] = useState("");


    const getEventDataFooter = (e) => {

        const myurl = "https://events.teambuildingawards.com:3000/api/web/list-events";
        var bodyFormData = new URLSearchParams();
        bodyFormData.append('page', '3');
        bodyFormData.append('host_id', '');
        bodyFormData.append('type', '2');
        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then((response) => {
            //console.log("AF",response?.data?.data);
            setEvents(response?.data?.data);

        }).catch((error) => {
            console.log("Errors", error);
            setDisable(false);
        })

    }

    const callPageReload = (e) => {
        window.scrollTo({ behavior: 'smooth', top: 0 })
    }
    const callPageReloadCat = (e) => {
        if (location.pathname == '/events') {
            window.location.reload();
            window.scrollTo({ behavior: 'smooth', top: 0 })
        } else {
            window.scrollTo({ behavior: 'smooth', top: 0 })
        }
    }
    const getCategoryDataFooter = (e) => {

        const myurl = "https://events.teambuildingawards.com:3000/api/web/list-category";
        var bodyFormData = new URLSearchParams();
        bodyFormData.append('category', 'refresh');
        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then((response) => {
            //console.log("AF",response?.data?.data);
            setCategories(response?.data?.data);

        }).catch((error) => {
            console.log("Errors", error);
            setDisable(false);
        })

    }

    const getCMSData = (e) => {

        const myurl = "https://events.teambuildingawards.com:3000/api/web/get-cms";
        var bodyFormData = new URLSearchParams();
        bodyFormData.append('cms', 'refresh');
        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then((response) => {
            setFb(response?.data?.data?.fb_link);
            setLinkedin(response?.data?.data?.linkedin_link);
            setTwitter(response?.data?.data?.twitter_link);
            setInsta(response?.data?.data?.insta_link);
            setFooterText(response?.data?.data?.footer_text);

        }).catch((error) => {
            console.log("Errors", error);
            setDisable(false);
        })

    }

    return (
        <>

            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-logo">
                            <img src="/assets/images/logo.png" alt="" className="img-fluid" />
                        </div>
                        <div className="footer-link-item">
                            <li className="tba-footer-menu-item">
                                <NavLink to="/contact-us" className="footer-link">Contact Us</NavLink>
                            </li>
                            <li className="tba-footer-menu-item">
                                <NavLink to="/about-us" className="footer-link">About Us</NavLink>
                            </li>
                            <li className="tba-footer-menu-item">
                                <NavLink to="/faq" className="footer-link">FAQ</NavLink>
                            </li>
                            <li className="tba-footer-menu-item">
                                <a href="https://teambuildingawards.com/blog" className="footer-link">Blog</a>
                            </li>
                            {/* <li className="tba-footer-menu-item">
                                <NavLink to="/terms-of-use" className="footer-link">Terms of Use</NavLink>
                            </li>
                            <li className="tba-footer-menu-item">
                                <NavLink to="/privacy-policy" className="footer-link">Privacy Policy</NavLink>
                            </li> */}

                            <div className="footer-social-link">
                                <li className="footer-link-list">
                                    <a href={fb} className="footer-link" target="_blank">
                                        <i className="fa-brands fa-facebook-f"></i>
                                    </a>
                                </li>
                                <li className="footer-link-list">
                                    <a href={linkedin} className="footer-link" target="_blank">
                                        <i className="fa-brands fa-linkedin-in"></i>
                                    </a>
                                </li>
                                <li className="footer-link-list">
                                    <a href={twitter} className="footer-link" target="_blank">
                                        <i className="fa-brands fa-twitter"></i>
                                    </a>
                                </li>
                                <li className="footer-link-list">
                                    <a href={insta} className="footer-link" target="_blank">
                                        <i className="fa-brands fa-instagram"></i>
                                    </a>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            {/* ============================================================================= */}


            <footer className="tba-site-footer" style={{ display: "none" }}>
                <div className="container">
                    <div className="row">
                        <div className="col col-12 col-md-6 col-lg-3">
                            <div className="tba-site-about">
                                <p className="tba-section-description">{footerText}</p>
                                <ul className="tba-social-list">
                                    <li className="tba-social-item">
                                        <a href={fb} className="tba-social-link" target="_blank">
                                            <i className="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li className="tba-social-item">
                                        <a href={linkedin} className="tba-social-link" target="_blank">
                                            <i className="fa-brands fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                    {/* <li className="tba-social-item">
                            <a href={twitter} className="tba-social-link" target="_blank">
                                <i className="fa-brands fa-twitter"></i>
                            </a>
                        </li>
                        <li className="tba-social-item">
                            <a href={insta} className="tba-social-link" target="_blank">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        </li> */}
                                </ul>
                            </div>
                        </div>
                        {/* <div className="col col-12 col-md-6 col-lg-3 ms-auto">
                <div className="tba-footer-menu">
                    <h3 className="tba-footer-menu-title">Inspirational Events</h3>
                    <ul className="tba-footer-menu-list">
                    { events.length > 0 ?
                                    events.map(row =>
                        <li className="tba-footer-menu-item" onClick={callPageReload}>
                            <a onClick={() => {
                                    history.push({
                                      pathname: '/event-details',
                                      state: {
                                        eventsData: row,
                                      },
                                    });
                                  }} className="tba-footer-menu-link event-cursor-pointer">{row.title}</a>
                        </li>
                        )
                        : ''
                    }
                        
                    </ul>
                </div>
            </div> */}

                        <div className="col col-12 col-md-6 col-lg-3 ms-auto">
                            <div className="tba-footer-menu">
                                <h3 className="tba-footer-menu-title">About us</h3>
                                <ul className="tba-footer-menu-list">
                                    <li className="tba-footer-menu-item">
                                        <NavLink to="/contact-us" className="tba-footer-menu-link">Contact Us</NavLink>
                                    </li>
                                    <li className="tba-footer-menu-item">
                                        <NavLink to="/about-us" className="tba-footer-menu-link">About Us</NavLink>
                                    </li>
                                    {/* <li className="tba-footer-menu-item">
                            <NavLink to="/contact-us" className="tba-footer-menu-link">Help Center</NavLink>
                        </li> */}
                                    <li className="tba-footer-menu-item">
                                        <a href="https://teambuildingawards.com/blog" className="tba-footer-menu-link">Blog</a>
                                    </li>
                                    <li className="tba-footer-menu-item">
                                        <NavLink to="/terms-of-use" className="tba-footer-menu-link">Terms of Use</NavLink>
                                    </li>
                                    <li className="tba-footer-menu-item">
                                        <NavLink to="/privacy-policy" className="tba-footer-menu-link">Privacy Policy</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col col-6 col-md-6 col-lg-3">
                            <div className="tba-footer-menu">
                                <h3 className="tba-footer-menu-title">Join Us</h3>
                                <ul className="tba-footer-menu-list">
                                    <li className="tba-footer-menu-item">
                                        <a href="javascript:void(0);" className="tba-footer-menu-link">FAQ</a>
                                    </li>
                                    <li className="tba-footer-menu-item">
                                        <a href="javascript:void(0);" className="tba-footer-menu-link">How it Works</a>
                                    </li>

                                    {localStorage.getItem("TBA_CLIENT_ID") ?

                                        ""

                                        :
                                        <li className="tba-footer-menu-item">
                                            <NavLink to="/contact-us" className="tba-footer-menu-link" data-bs-toggle="modal" data-bs-target="#tbaRegisterModal" >Become a Host</NavLink>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col col-6 col-md-6 col-lg-2">
                            <div className="tba-footer-menu">
                                <h3 className="tba-footer-menu-title">Events</h3>
                                <ul className="tba-footer-menu-list">
                                    {categories.length > 0 ?
                                        categories.map(row =>
                                            <li className="tba-footer-menu-item" onClick={callPageReloadCat}>
                                                {/* <NavLink to="/events" className="tba-footer-menu-link">{row.name}</NavLink> */}

                                                <a
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        history.push({
                                                            pathname: '/events',
                                                            state: {
                                                                cat_id: row.category_id,
                                                                master_cat_id: row.master_category_id,
                                                            },
                                                        });
                                                    }}
                                                >{row.name}</a>

                                            </li>
                                        )
                                        : ''
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
